// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ReceiptEditIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ReceiptEdit/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.15 1.667h-6.3c-3.15 0-3.933.841-3.933 4.2v9.383c0 2.217 1.216 2.742 2.691 1.158l.009-.008c.683-.725 1.725-.667 2.316.125l.842 1.125c.675.892 1.767.892 2.442 0l.841-1.125c.6-.8 1.642-.858 2.325-.125 1.484 1.583 2.692 1.058 2.692-1.158V5.867c.008-3.359-.775-4.2-3.925-4.2Zm-.783 6.658-.417.425h-.008l-2.525 2.525a.98.98 0 0 1-.492.242l-1.125.166c-.408.059-.692-.233-.633-.633l.158-1.133c.025-.159.133-.375.242-.492L10.1 6.9l.417-.425C10.792 6.2 11.1 6 11.433 6c.284 0 .592.133.934.475.75.75.508 1.342 0 1.85Z"
}));
export default ReceiptEditIcon;